import React from 'react';
import SelectionListItem from '@wix/da-ds/pkg/SelectionList/SelectionListItem';
import FavStarFill from '@wix/da-ds/pkg/Icons/24x24/FavStarFill';
import GallectionCoverDumbo from '../GallectionCoverDumbo';
import s from './GallectionListItem.scss';
var GallectionListItem = function (_a) {
    var gallection = _a.gallection, isSelected = _a.isSelected, isDisabled = _a.isDisabled, control = _a.control, showSuffixOnlyOnHover = _a.showSuffixOnlyOnHover, suffix = _a.suffix, onChange = _a.onChange, onClick = _a.onClick;
    return (React.createElement(SelectionListItem, { isSelected: isSelected, isDisabled: isDisabled, control: control, showSuffixOnlyOnHover: showSuffixOnlyOnHover, suffix: suffix, label: gallection.name, name: gallection.name, prefix: React.createElement(GallectionCoverDumbo, { width: 70, height: 40, gallection: gallection, className: s['cover'], placeholderClassName: s['cover-placeholder'], placeholder: React.createElement(FavStarFill, null) }), fillContainerWidth: true, onChange: onChange &&
            (function (isSelectedNew) {
                return onChange({
                    folderId: gallection.folderId,
                    isSelected: isSelectedNew,
                });
            }), onClick: onClick && (function () { return onClick(gallection.folderId); }) }));
};
GallectionListItem.displayName = 'GallectionListItem';
export default GallectionListItem;
//# sourceMappingURL=GallectionListItem.js.map